export const state = {
  contato: {
    nome: "",
    nome_fantasia: "",
    cpf_cnpj: "",
    tipo_pessoa: "",
    rg: "",
    ie: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    uf: "",
    whatsapp: "",
    telefone: "",
    celular1: "",
    celular2: "",
    email_notas: "",
    email: "",
    proxima_visita: "",
    data_nascimento: "",
    sexo: "",
    observacoes: "",
  },
  contatos: [],
  transportadoras: [],
  fornecedores: [],
  modalExcluirContato: false,
  modalPesquisarContato: false,
  modalCadastroContato: false,
  tiposContatos: ["CLIENTE", "FORNECEDOR", "TRANSPORTADORA"],
  estadoSelecionadoContato: {},
  cidadeSelecionadaContato: {},
};

export default {};
